import { render, staticRenderFns } from "./XPeriodoFiscalTag.vue?vue&type=template&id=4bf3da77&"
import script from "./XPeriodoFiscalTag.vue?vue&type=script&lang=js&"
export * from "./XPeriodoFiscalTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports